import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';

export const isSmimeAdminSettingEnabled = (): boolean => {
    if (!isFeatureEnabled('cmp-smimeAdminSettings')) {
        return false;
    }
    const userConfig = getUserConfiguration();
    return (
        userConfig &&
        userConfig.SmimeAdminSettings &&
        (userConfig.SmimeAdminSettings.AlwaysEncrypt || userConfig.SmimeAdminSettings.AlwaysSign)
    );
};

export const isSmimeUserSettingEnabled = (): boolean => {
    if (!isFeatureEnabled('cmp-smimeAdminSettings')) {
        return false;
    }
    const userConfig = getUserConfiguration();
    return (
        userConfig &&
        userConfig.UserOptions &&
        (userConfig.UserOptions.SmimeEncrypt || userConfig.UserOptions.SmimeSign)
    );
};

export const isSmimeSettingEnabled = (): boolean => {
    return isSmimeUserSettingEnabled() || isSmimeAdminSettingEnabled();
};
